import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { switchMap } from "rxjs/operators";
import { combineLatest } from "rxjs";
import { SubSink } from "subsink";

import { PageService, ConfigurationService } from "@/shared-module/services";
import { Submenu, Configuration } from "@/shared-module/models";
import { ZoneItem } from "@/shared-module/components";

@Component({ templateUrl: "market.component.html" })
export class MarketComponent implements OnInit, OnDestroy {
  title: string;
  subtitle: string;
  zones: ZoneItem[] = [];
  subMenu: Submenu;
  configuration: Configuration;
  nextDecision: Date;
  path: string;
  subpath: string;
  token: string;
  subs = new SubSink();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pageService: PageService,
    private configurationService: ConfigurationService,
  ) {}

  ngOnInit() {
    const thisObject = this;

    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => (thisObject.configuration = c),
    );

    const combine = combineLatest(
      this.route.params,
      this.route.queryParams,
    ).pipe(switchMap((results) => this.getObservable()));
    this.subs.sink = combine.subscribe((s: any) => this.loadPageContent(s));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  loadPageContent(s: any) {
    if (this.redirect(s.redirectPath)) {
      return;
    }

    this.subMenu = s.subMenu;
    this.title = s.title;
    this.subtitle = s.subTitle;
    this.nextDecision = s.nextDecision;
    this.token = s.userPilotToken;
    this.load(s.zones);
  }

  /**
   * The server answers with a redirectPath when the requested page is not available any more —
   * a faculty flag (ShowMcKinsey, hidden rankings) can hide a page while the student is on it.
   * Replace the dead url with the fallback page the server picked, so that the sub-menu
   * selection matches the content and the back button does not return to the dead page.
   */
  redirect(redirectPath: string): boolean {
    if (!redirectPath) {
      return false;
    }

    const segments = this.router.url.split("?")[0].split("/");
    const nbPathParams =
      (this.route.snapshot.paramMap.has("path") ? 1 : 0) +
      (this.route.snapshot.paramMap.has("subpath") ? 1 : 0);
    const base = segments.slice(0, segments.length - nbPathParams).join("/");
    const target = `${base}/${redirectPath}`;

    if (target === this.router.url.split("?")[0]) {
      return false;
    }

    this.router.navigateByUrl(target, { replaceUrl: true });
    return true;
  }

  getObservable() {
    let path: string;
    let subpath: string;
    if (this.route.snapshot.paramMap.has("path")) {
      path = this.route.snapshot.paramMap.get("path");
    }
    if (this.route.snapshot.paramMap.has("subpath")) {
      subpath = this.route.snapshot.paramMap.get("subpath");
    }
    const regionParam = this.route.snapshot.queryParams;
    return this.pageService.getpath("market", path, subpath, regionParam);
  }

  load(zones: any[]) {
    this.zones = [];

    if (zones) {
      zones.forEach((zoneitm) => {
        this.zones.push(
          new ZoneItem(
            zoneitm.zoneType,
            zoneitm.title,
            zoneitm.dataSource,
            zoneitm.error,
            zoneitm.width,
            false,
          ),
        );
      });
    }
  }
}
